import React from 'react';
import { WalletIcon } from '@heroicons/react/24/solid';
import SkeletonLoader from './SkeletonLoader';
import { CreditBalanceProps } from '../interface/interface';

const CreditBalance: React.FC<CreditBalanceProps> = ({
  credits,
  isCreditsLoading,
}) => {
  return (
    <div className="rounded-lg shadow bg-secondary-tangerine-50 text-secondary-tangerine-700 px-8 py-2.5 text-lg font-semibold flex justify-center items-center w-full md:w-80">
      <WalletIcon className="w-6 h-8 fill-secondary-tangerine-600" />
      <span className="ml-3 text-secondary-tangerine-700">credit balance</span>

      {isCreditsLoading ? (
        <SkeletonLoader className="mr-3 w-10 h-7 text-bg--700" />
      ) : (
        <span className="ml-3 text-lg font-regular text-secondary-tangerine-800">
          ${credits?.toFixed(2)}
        </span>
      )}
    </div>
  );
};

export default CreditBalance;
